import * as React from 'react';
import { useEffect, useState } from 'react';
import PhotoTile, { IPhotoTileProps } from './PhotoTile';

interface ITargetPhotoTile {
	target: null | { current: { clientWidth: number } };
}

const PhotoTilePreview: React.FC<IPhotoTileProps & ITargetPhotoTile> = (props) => {
	// Set the width of the preview tile to match the width of the grabbed tile.
	// This is necessary because the preview tile is not bound by anything.
	const [width, setWidth] = useState(0);

	useEffect(() => {
		const { target } = props;
		if (target) {
			setWidth(target.current.clientWidth);
		}
	}, [props.target]);

	return <div style={{ width: `${width}px` }}>
		<PhotoTile {...props} isGrabbing={true} onUpClick={undefined} onDownClick={undefined} />
	</div>;
};

export default PhotoTilePreview;
